import React from 'react';
import { Button } from 'tuui';
import { FormattedMessage } from '../../../../modules/taboola-common-frontend-modules/i18n';
import styles from './mainFilters.module.scss';

export const MainFilters = ({ filters, onClick }) => {
    const comps = filters.map((filter, index) => {
        return (
            <Button key={index} type="text" onClick={() => onClick(filter)} className={styles['filter-button']}>
                <FormattedMessage
                    id={`campaign.editor.targeting.my-audiences.${filter.fieldName}.filter.name`}
                    defaultMessage="{detail}"
                    values={{ detail: filter.name }}
                />
            </Button>
        );
    });

    return <div className={styles['container']}>{comps}</div>;
};
